import React from 'react'
import { Link } from 'react-router-dom'
import useMeta from '../hooks/useMeta'

export default function NotFound() {
  useMeta('Siden blev ikke fundet', 'Siden blev ikke fundet.')
  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center bg-brand-light px-6 text-center">
      <div className="flex h-20 w-20 items-center justify-center rounded-full bg-brand-blue/10 text-brand-blue mb-6">
        <i className="fa-solid fa-triangle-exclamation text-4xl"></i>
      </div>
      <h1 className="text-4xl font-extrabold text-brand-navy tracking-tight sm:text-5xl">
        404 - Siden blev ikke fundet
      </h1>
      <p className="mt-4 text-base text-brand-text-muted max-w-md leading-relaxed">
        Beklager, men den side du leder efter findes ikke eller er blevet flyttet. Brug menuen ovenfor eller klik på knappen under for at gå tilbage til forsiden.
      </p>
      <div className="mt-8">
        <Link
          to="/"
          className="rounded-lg bg-brand-navy px-6 py-3.5 text-sm font-bold text-white transition-all duration-200 hover:bg-brand-darkblue shadow-md"
        >
          Gå til forsiden
        </Link>
      </div>
    </div>
  )
}
